import React from "react";
import Nav from "react-bootstrap/Nav";
import { useAppContext } from "../libs/contextLib";
import "./Menu.css";

export default function Home() {
  const { userProfile } = useAppContext();
  return (
    <div className="Home">
      <h1 id="page_title">会員専用サイト</h1>
      <div className="container">
        <div id="sub_page">
          <div id="mypage" className="top">
              <section>
                <div className="inner">
                  <ul>
                    <li className="menuHidden">
                      <Nav.Link href="signup?opt=1&mt=1">申込画面（正会員）</Nav.Link>
                    </li>
                    <li className="menuHidden">
                      <Nav.Link href="signup?opt=2&mt=4">申込画面（准会員）</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=rm">正会員用マイページ</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=am">准会員用マイページ</Nav.Link>
                    </li>
                    <li>
                      <Nav.Link href="/login?m=st">学生会員用マイページ</Nav.Link>
                    </li>
                    <li className="menuHidden">
                      <Nav.Link href="/login?m=ad">管理画面</Nav.Link>
                    </li>
                  </ul>
          <p style={{"max-width": "580px", "text-align": "center", "margin": "2em auto"}}>※「スポーツ医学 現場見学・研修マッチングプログラム」および<br/>
                 「学会誌抄録号」へアクセスするには、会員専用サイトへの<br/>
                  ログインが必要となります。</p>

                </div>
              </section>
          </div>
        </div>
      </div>
      
    </div>
  );
}
